import type { ItemType } from "core/entities";
import { useCentrixApiInfinite } from "core/hooks/useCentrixApiInfinite";
import { useLocale } from "core/hooks/useLocale";

export function useGlobalSearch(
  filterText: string,
  itemType?: Exclude<ItemType, "External">
) {
  const locale = useLocale();
  const {
    data,
    items,
    totalCount,
    isLoadingInitialData,
    isLoadingMore,
    isError,
    mutate,
    currentCount,
    loadMore,
    showLoadMore,
  } = useCentrixApiInfinite({
    path: "/api/app/search",
    parameters: {
      query: { FilterText: filterText, Locale: locale, ItemType: itemType },
    },
    maxResultCount: 10,
  });

  return {
    data,
    items,
    totalCount,
    isLoadingInitialData,
    isLoadingMore,
    isError,
    mutate,
    currentCount,
    loadMore,
    showLoadMore,
  };
}
